export default __webpack_public_path__ + "static/media/fall.29077e26.gif";